export default "__VITE_ASSET__acb2022e__"